import { TeamsUser } from "@teams/types";
import { ScheduleDTO } from "@teams/types/api";
import React, { useState } from "react";

import { isError } from "../../../services/ChannelApi";
import { scheduleApi } from "../../../services/ScheduleApi";
import { useTeamsContext } from "../../../state/TeamsContextProvider";
import { PollyDialog } from "../../PollyDialog";
import { UsersAndPermissions } from "../../UsersAndPermissions";

type ShareScheduleDialogParams = {
  schedule: ScheduleDTO;
  onChanged: () => void;
  setIsOpen: (open: boolean) => void;
};

export const ShareScheduleDialog: React.FC<ShareScheduleDialogParams> = ({
  schedule,
  onChanged,
  setIsOpen,
}) => {
  const { teamsContext } = useTeamsContext();
  const [owners, setOwners] = useState(schedule.owners);
  const [changedOwners, setChangedOwners] = useState<boolean>(false);

  return (
    <PollyDialog
      open
      onCancel={() => {
        setIsOpen(false);
        if (changedOwners) {
          onChanged();
        }
      }}
      header="Sharing"
    >
      <div className="series-menu__users-dialog">
        <UsersAndPermissions
          ownersHeader="Series management"
          ownersHeaderDescription="Users that have management access to this series and its results"
          canOwn={schedule.role === "own"}
          owners={owners}
          onAddOwner={async owner => {
            if (schedule.role !== "own") {
              return;
            }

            const newOwner: TeamsUser = {
              aadObjectId: owner.aadObjectId,
              name: owner.name,
              teamsUserId: owner.id,
              upn: owner.userPrincipalName,
            };

            const result = await scheduleApi.addOwner(teamsContext, schedule.id, newOwner);
            if (!isError(result)) {
              setOwners([...owners, newOwner]);
              setChangedOwners(true);
            }
            return result;
          }}
          onRemoveOwner={async user => {
            if (schedule.role !== "own") {
              return;
            }

            const result = await scheduleApi.removeOwner(
              teamsContext,
              schedule.id,
              user.aadObjectId
            );
            if (!isError(result)) {
              setOwners(owners.filter(o => o.aadObjectId !== user.aadObjectId));
              setChangedOwners(true);
            }
            return result;
          }}
        />
      </div>
    </PollyDialog>
  );
};
